(function () {
  angular
    .module('kareo.ui.shared.directives.k-edit-patient.private.k-escape-html', [])
    .directive('kEscapeHtml', kEscapeHtml);

  function kEscapeHtml() {
    return {
      restrict: 'A', // only activate on element attribute
      require: 'ngModel', // get a hold of NgModelController
      link(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(escapeHtml);
        ngModel.$formatters.push(unescapeHtml);
      }
    };
  }

  var charToSpecialChar = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
  };

  var specialCharToChar = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#039;': '\''
  };

  function escapeHtml(unsafe) {
    var currentChar, escapedStr, i;

    if (typeof unsafe !== 'string') {
      return unsafe;
    }

    escapedStr = '';

    for (i = 0; i < unsafe.length; i++) {
      currentChar = unsafe[i];
      escapedStr += charToSpecialChar.hasOwnProperty(currentChar) ?
                    charToSpecialChar[currentChar] :
                    currentChar;
    }

    return escapedStr;
  }

  function unescapeHtml(safe) {
    var currentChar, i, unescapedStr;

    if (typeof safe !== 'string') {
      return safe;
    }

    unescapedStr = '';

    for (i = 0; i < safe.length; i++) {
      currentChar = safe[i];
      unescapedStr += specialCharToChar.hasOwnProperty(currentChar) ?
                      specialCharToChar[currentChar] :
                      currentChar;
    }

    return unescapedStr;
  }
})();
